@if (entry.base?.display) {
    <form [formGroup]="form" [connect]="'payloadStates.' + entry.formControlAttributes.connectPath" class="event-form"></form>
    @if(eventForm){
      <form [formGroup]="eventForm" class="event-form-proxy">
      <!--Dropdown for life events-->
      <mat-form-field appearance="outline" class="event" [style.width]="fieldWidth" >
        <mat-label>{{entry.formControlAttributes?.label || 'Date of Life Event' }}</mat-label>
        <mat-select aria-label="Qualifying Life Event" [formControlName]="entry.formControlAttributes.formControlName" [compareWith]="compareWithFn" (selectionChange)="eventChanged('change',$event)">
          @for (lifeEvent of qualifyingLifeEvents; track lifeEvent) {
            <mat-option [value]="lifeEvent">
              {{lifeEvent.lifeEventDescription}}
            </mat-option>
          }
        </mat-select>
        @if (eventFormControls[entry.formControlAttributes.formControlName].errors?.required) {
          <mat-error>{{entry.custom?.lifeEventRequiredErrorMessage || 'Required'}}</mat-error>
        }
      </mat-form-field>
    </form>
  }
}